export type BlockVisibility = {
  hideOnMobile?: boolean;
  hideOnDesktop?: boolean;
};

export function hiddenOn({ hideOnMobile, hideOnDesktop }: BlockVisibility): { mobile: boolean; desktop: boolean } {
  if (hideOnMobile && hideOnDesktop) {
    return { mobile: false, desktop: false };
  }

  return { mobile: Boolean(hideOnMobile), desktop: Boolean(hideOnDesktop) };
}

export function activeHidden(visibility: BlockVisibility): string {
  const hidden = hiddenOn(visibility);
  const classes: string[] = [];

  if (hidden.mobile) classes.push('active-hidden-mobile');
  if (hidden.desktop) classes.push('active-hidden-desktop');

  return classes.join(' ');
}
